<script setup lang="ts">
import { PokerlySymbolBrandNegative } from '@/assets/pokerly/index.js';
import { PButton } from '@pokerly/ui';
import { ref, onMounted, onUnmounted } from 'vue';

const showTrigger = ref(false);
const TRIGGER_ZONE_PX = 50; // pixels from right edge to trigger visibility

function onMouseMove(event: MouseEvent) {
    const distFromRight = window.innerWidth - event.clientX;
    showTrigger.value = distFromRight < TRIGGER_ZONE_PX;
}

onMounted(() => {
    window.addEventListener('mousemove', onMouseMove);
});

onUnmounted(() => {
    window.removeEventListener('mousemove', onMouseMove);
});

defineEmits<{
    click: [];
}>();
</script>

<template>
    <transition name="fade">
        <PButton
            data-class="pokerly-dev-tools-trigger"
            variant="secondary"
            v-if="showTrigger"
            class="h-10 w-20 justify-start z-9998 cursor-pointer fixed right-0 top-1/2 border-2 border-border-default transform-[translateY(-50%)_translateX(50%)]"
            @click="$emit('click')"
            title="Open Pokerly Dev Tools"
            rounded
        >
            <PokerlySymbolBrandNegative />
        </PButton>
    </transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: all 0.2s ease;
    transform: translateY(-50%) translateX(50%);
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
    transform: translateY(-50%) translateX(100%);
}
</style>
